import { getShiftKey } from "@/constants/shifts";

const STORAGE_PREFIX = "rm-packing";

/**
 * Ključ čekliste pakovanja: po restoranu i periodu (isti za telefon i računar). Smena je deo ključa
 * stavke (packingItemKey), pa izbor smena u traci ne briše šta je već spakovano.
 */
export const packingStorageKey = (restaurantId, from, to) =>
  [STORAGE_PREFIX, restaurantId, from, to].join(":");

/** Stavka čekliste je jelo u jednoj smeni: pakuje se i nosi po smeni. */
export const packingItemKey = (mealId, shiftId) => `${mealId}:${shiftId}`;

/** { [nazivFirme]: { items: { [mealId:shiftId]: true }, ready: boolean } } */
export const readPackingState = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || {};
  } catch (error) {
    return {};
  }
};

export const writePackingState = (key, state) => {
  try {
    localStorage.setItem(key, JSON.stringify(state));
  } catch (error) {
    // Bez localStorage-a čeklista radi samo dok je ekran otvoren.
  }
};

/**
 * Zbir pakovanja za značku u meniju: firme sa obrocima, spakovano i firme označene kao spremne.
 * @param {Array} report firme iz transformMealsForPackages
 * @param {object} state stanje čekliste (readPackingState)
 * @param {number[]} shifts izabrane smene
 */
export const summarizePacking = (report, state, shifts) => {
  let companies = 0;
  let ready = 0;
  let total = 0;
  let done = 0;
  (report || []).forEach((company) => {
    const saved = state[company.name] || { items: {}, ready: false };
    let companyTotal = 0;
    let companyDone = 0;
    (company.meals || []).forEach((meal) => {
      shifts.forEach((shiftId) => {
        const quantity = meal[getShiftKey(shiftId)]?.totalQuantity || 0;
        if (quantity > 0) {
          companyTotal += quantity;
          if (saved.items?.[packingItemKey(meal.id, shiftId)]) {
            companyDone += quantity;
          }
        }
      });
    });
    if (companyTotal > 0) {
      companies += 1;
      total += companyTotal;
      done += companyDone;
      if (companyDone === companyTotal && saved.ready) {
        ready += 1;
      }
    }
  });
  return { companies, ready, total, done };
};
